import React from 'react';
import { createIcon } from './create-icon';
import './icon-close-thin.scss';

export const IconCloseThin = createIcon(<div className="icon-close-thin" />);
